// import { useChat } from "../context/ChatProvider";
import React,{useContext} from "react";
import { useChat } from "../../context/provider/ChatProvider";
import { UserContext } from "../../context/provider/UserProvider";



const useChatActions = () => {
    const { socket } = useChat();
    const {stateUser} = useContext(UserContext)
    // const joinRoom = (roomID) => {
    //     socket.emit('join-room', roomID);
    // }

    const joinRoom = (room) => {
        socket.emit('join-room', {
            "roomId": room.roomID,
            "nickname": stateUser.uid
        });

            // socket.emit('join-room',
            //     {"roomId": widget.roomId, "nickname": widget.myNickname});

    }


    const leaveRoom = (roomID) => {
        socket.emit('leave-room', {nickname: stateUser.uid, roomId: roomID});
    }

    const sendMessage = ( roomId, text, userName, messageType, mediaFile ) => {
        if(! text && messageType === "text" && mediaFile === "") {
            return;
        }
        
        socket.emit('send-message', {
            "room": roomId,
            "content": text.toString(),
            "messageType": messageType,
            "media": mediaFile
        });

    }

    return {
        joinRoom,
        sendMessage,
        leaveRoom
    }
};

export default useChatActions;






// Enviar mensaje

//   void sendMessage() {
//     if (_textController.text.isEmpty) return;
//     socket.emit('send-message', {
//       "room": widget.roomId,
//       "content": _textController.text,
//       "messageType": "text"
//     });
//     _textController.clear();

//     ///scrrol de msm
//     WidgetsBinding.instance!.addPostFrameCallback((_) {
//       _scrollToBottom();
//     });
//   }

